import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedViewFilter from 'mini-mail-list-store/lib/utils/getFocusedViewFilter';
import type NativeAdPlacement from '../store/schema/NativeAdPlacement';
import { getIsShowMultipleAds } from './getIsShowMultipleAds';
import { getNativeAdShowStatus, type NativeAdUserFlight } from 'mini-mail-nativead-userchecker';

/**
 * This util returns the index of Default Ad and Floating Ad in the Mail List according to current placement.
 * @returns [firstIndex, secondIndex] where firstIndex is the index of Floating Ad (multiple ads)/ Fixed ad(Single ad) and secondIndex is the index of Fixed Ad.
 */

export const getAdIndexName = (adPlacement?: NativeAdPlacement) => {
    if (!adPlacement) {
        adPlacement = getAdPlacement();
    }

    let firstIndex: NativeAdPlacement;
    let secondIndex: NativeAdPlacement;
    const isShowMultipleAd = getIsShowMultipleAds();

    switch (adPlacement) {
        case 'FocusPivot':
            firstIndex = 'FocusPivot';
            break;
        case 'MiniHeader':
            firstIndex = 'MiniHeader';
            break;
        case 'InboxFixed':
        case 'InboxFloating':
            firstIndex = isShowMultipleAd ? 'InboxFloating' : 'InboxFixed';
            secondIndex = 'InboxFixed';
            break;
        case 'OtherPivotFixed':
        case 'OtherPivotFloating':
            firstIndex = isShowMultipleAd ? 'OtherPivotFloating' : 'OtherPivotFixed';
            secondIndex = 'OtherPivotFixed';
            break;
    }
    return [firstIndex, secondIndex];
};

/**
 * This util returns the current Ad Placement based on user's ads preference and current view (Focused, Other, inbox) .
 * @returns Ad Placement
 */

export const getAdPlacement = (): NativeAdPlacement => {
    if (getNativeAdShowStatus() === 2) {
        return 'MiniHeader';
    }

    const focusedViewFilter = getFocusedViewFilter();
    if (focusedViewFilter === 0) {
        return 'FocusPivot';
    } else if (focusedViewFilter === 1) {
        return 'OtherPivotFixed';
    }

    return 'InboxFixed';
};
